import { Slider, Stack } from "@mui/material";
import { Switches } from "mui-rff";
import { useEffect } from "react";
import { useField, useForm } from "react-final-form";

export type ZoomLevelOptions = {
  min_allowed_zoom_level_override?: number;
  max_allowed_zoom_level_override?: number;
};

interface ZoomConfigurationProps {
  name: string;
  initialValue?: ZoomLevelOptions;
}

const ZoomConfiguration = ({ name, initialValue }: ZoomConfigurationProps) => {
  const form = useForm();
  const zoomEnabledField = useField(`${name}.zoom_enabled`, {
    initialValue:
      !!initialValue?.min_allowed_zoom_level_override ||
      !!initialValue?.max_allowed_zoom_level_override,
  });
  const minAllowedZoomField = useField(`${name}.min_allowed_zoom_level_override`, {
    initialValue: initialValue?.min_allowed_zoom_level_override ?? 4,
  });
  const maxAllowedZoomField = useField(`${name}.max_allowed_zoom_level_override`, {
    initialValue: initialValue?.max_allowed_zoom_level_override ?? 6,
  });

  useEffect(() => {
    form.batch(() => {
      if (!zoomEnabledField.input.value) {
        form.change(`${name}.min_allowed_zoom_level_override`, null);
        form.change(`${name}.max_allowed_zoom_level_override`, null);
      } else {
        if (!minAllowedZoomField.input.value) {
          form.change(`${name}.min_allowed_zoom_level_override`, 4);
        }
        if (!maxAllowedZoomField.input.value) {
          form.change(`${name}.max_allowed_zoom_level_override`, 6);
        }
      }
    });
  }, [
    zoomEnabledField.input.value,
    minAllowedZoomField.input.value,
    maxAllowedZoomField.input.value,
  ]);

  return (
    <Stack direction="row" alignItems="center">
      <div style={{ minWidth: "40%" }}>
        <Switches
          name={`${name}.zoom_enabled`}
          data={{
            label: "Override zoom levels",
            value: true,
          }}
        />
      </div>
      {zoomEnabledField.input.value && (
        <Slider
          name={`${name}.min_allowed_zoom`}
          onChange={(e, v) => {
            if (Array.isArray(v)) {
              form.change(`${name}.min_allowed_zoom_level_override`, v[0]);
              form.change(`${name}.max_allowed_zoom_level_override`, v[1]);
            }
          }}
          value={[minAllowedZoomField.input.value, maxAllowedZoomField.input.value]}
          min={1}
          max={14}
          valueLabelDisplay="auto"
        />
      )}
    </Stack>
  );
};

export default ZoomConfiguration;
